export class LoanInfo {
  constructor(propertyIdentifier, currentLoanAssumptions = {}, cashOutResults = {}, aggregatedData = {}, saveProposalResults = {}, propertyInfo = {}, ficoInfo = {}, loanCards = [], selectedCardId = '', shouldCallValueCheck = false) {
    this.application_data = {
      estimatedMortageBalance: currentLoanAssumptions?.estimatedMortageBalance || 0,
      estimatedInterestRate: currentLoanAssumptions?.estimatedInterestRate || 0,
      estimatedMonthlyPayment: currentLoanAssumptions?.estimatedMonthlyPayment || 0,
      estimatedSecondMortgageBalance: currentLoanAssumptions?.estimatedSecondMortgageBalance || 0,
      estimatedSecondInterestRate: currentLoanAssumptions?.estimatedSecondInterestRate || 0,
      estimatedSecondMonthlyPayment: currentLoanAssumptions?.estimatedSecondMonthlyPayment || 0,
      estimatedSecondCurrentLoanAmount: currentLoanAssumptions?.estimatedSecondCurrentLoanAmount || 0,
      estimatedSecondCurrentLoanType: currentLoanAssumptions?.estimatedSecondCurrentLoanType || '',
      includeSecondLoan: currentLoanAssumptions?.includeSecondLoan || 'No',
      estimatedHomeValue: currentLoanAssumptions?.estimatedHomeValue || 0,
      estimatedRemainingInterest: currentLoanAssumptions?.estimatedRemainingInterest || 0,
      occupancyType: currentLoanAssumptions?.occupancyType || 0,
      estimatedRemainingMonths: currentLoanAssumptions?.estimatedRemainingMonths || 0,
      estimatedPrincipalAndInterest: currentLoanAssumptions?.estimatedPrincipalAndInterest || 0,
      estimatedTaxes: currentLoanAssumptions?.estimatedTaxes || 0,
      estimatedPropertyInsurance: currentLoanAssumptions?.estimatedPropertyInsurance || 0,
      estimatedFloodInsurance: currentLoanAssumptions?.estimatedFloodInsurance || 0,
      estimatedMortgageInsurance: currentLoanAssumptions?.estimatedMortgageInsurance || 0,
      propertyType: currentLoanAssumptions?.propertyType || ' ',
      property_id: propertyIdentifier ? propertyIdentifier.toString() : 0,
      propertyValue: propertyInfo?.propertyValue?.toString() || 0,
      cashRequest: cashOutResults?.cashReq || 0,
      cashMortgage: cashOutResults?.cashMort || 0,
      loanToValue: cashOutResults?.ltv || 0,
      county: aggregatedData.savedCounty,
      address: aggregatedData.savedAddress,
      primary_reason: aggregatedData.refiReason,
      loanType: ficoInfo.loanType ?? 'Conforming',
      loanTerm: aggregatedData.currLoanTerm.toString(),
      secondLoanTerm: currentLoanAssumptions?.secondLoanTerm.toString(),
      salePrice: ficoInfo?.saleAmount || 0,
      salesDate: ficoInfo?.saleDate || '1900-01-01T00:00:00',
      originalLoanVal: currentLoanAssumptions?.originalLoanVal || 0,
      dueDate: aggregatedData.currDueDate ?? '-',
      docDate: ficoInfo.docDate ?? '-',
      user_credit: aggregatedData.user_credit,
      mortgages: propertyInfo.mortgages,
      confirmLoanOfficerToContact: saveProposalResults?.selectedLoanOfficerToContact ?? ' ',
      loanCards: loanCards || [],
      selectedCardId: selectedCardId || '',
      shouldCallValueCheck,
    };
    this.last_updated_app = 'refi-ui';
    if (saveProposalResults) {
      this.first_name = saveProposalResults.firstName;
      this.last_name = saveProposalResults.lastName;
      this.email = saveProposalResults.email;
      this.phone = saveProposalResults.phone || ' ';
      this.second_contact_first_name = saveProposalResults.secondContactFirstName || '';
      this.second_contact_last_name = saveProposalResults.secondContactLastName || '';
      this.second_contact_email = saveProposalResults.secondContactEmail || '';
      this.second_contact_phone = saveProposalResults.secondContactPhone || '';
      this.loan_officer_id = saveProposalResults.selectedLoanOfficer || null;
      this.rate_alert_opt_in = saveProposalResults.rateAlertOptIn;
    }
  }
}
